/* eslint-disable no-console,no-undef, camelcase, no-constant-condition */
import React, { Component } from "react";
import PropTypes from "prop-types";
import { toast } from "react-toastify";
import {
  getOrientation,
  resetOrientation,
  checkImage,
  fetchApi,
} from "../../../utils/methods";
import { imageErrorMessage } from "../../../utils/constants";
import { withTranslation } from "react-i18next";
import {
  Layout,
  Container,
  InputContainer,
  StyledInputV2,
  StyledLabel,
  ButtonContainer,
  EditorContainer
} from "../../CreateEvent/style";
import StepsHeading from "./stepNames";
import { Main } from "../../AdminTeamCreation/styles";
import Editor from "../../CKEditor";
import CommonDropdown from "../../common/CommonDropDown/CommonDropdown";
// import CommonButton from "../../common/CommonButton/CommonButton";
import {  AdminCloseIcon, AdminLeftArrowIcon, AdminRightArrowIcon, LaunchIcon, RecognitionCloseIcon, RecognitionBoldPencilIcon, RecognitionTickIcon,/*, UploadHDMIcon */
  AddIconRecognition} from "../../../utils/icons";
import { AddCompanyExemplifiesValues, GetCoreValueIcons, CreateCustomCoreValue } from "../../../redux/constants/apiConstants";
import { Border } from "../../Journeys/styles";
import { withRouter } from 'react-router-dom';
import { ImageUrl } from "../../../utils/constants";
import { ButtonWrapper, CircleButton, ColorBox, ColorGrid, EditButton, Heading, IconGrid, IconWrapper, ModalFooter, StyledModalV1, VerticalBorder } from "./styles";
import { ManagerIconContainer } from "../../Manager/styles";
import parse from 'react-html-parser';
import { /*ButtonCustom,*/ CommonButtonPopup } from "../../ReportsV2/styles";
// import { AdminIconContainer } from "../styles";
import { CommonButtonBorder } from "../../common/commonStyles";

class CreateCoreValue extends Component {
  constructor(props) {
    super(props);
    this.state = {
      title: "",
      description: "",
      imageName: "",
      eventPointKey: null,
      eventPointValue: null,
      colorCode: null,
      //   status: props.history?.location?.state?.status,
      recognitionId: null,
      color: "",
      so: false,
      step: 1,
      buttonStatus: false,
      selectedColor: null,
      icon: null,
      // iconData:[],
      selectedIconV1:null,
      selectedValueIconV1:null,
      selectedIcon: null,
      themeColor: null,
      showModal: false,
      iconColor: null,
      disableButton: false,
      coreValueIcons: null,
      isModalOpen: false,
      selectedColorV1: null,
      confirmColorV1: null,
      coreValueLibraryIcons: [],
      selectedValueIcon: null,
      isPopupOpen: false,
      pointsArray: [
        { value: 0, text: "0 Pts" },
        { value: 25, text: "25 Pts" },
        { value: 50, text: "50 Pts" },
        { value: 100, text: "100 Pts" },
        { value: 150, text: "150 Pts" },
        { value: 200, text: "200 Pts" },
        { value: 250, text: "250 Pts" },
        { value: 300, text: "300 Pts" },
        { value: 350, text: "350 Pts" },
        { value: 400, text: "400 Pts" },
        { value: 450, text: "450 Pts" },
        { value: 500, text: "500 Pts" },
        { value: 550, text: "550 Pts" },
        { value: 600, text: "600 Pts" },
        { value: 650, text: "650 Pts" },
        { value: 700, text: "700 Pts" },
        { value: 750, text: "750 Pts" },
        { value: 800, text: "800 Pts" },
        { value: 850, text: "850 Pts" },
        { value: 900, text: "900 Pts" },
        { value: 950, text: "950 Pts" },
        { value: 1000, text: "1000 Pts" }
      ],
      colors: [
        { name: "Red", colorCode: "#F37A65", backgroundImage: "admin-recognition/Red.png" },
        { name: "Blue", colorCode: "#92A4DA", backgroundImage: "admin-recognition/Blue.png" },
        { name: "Maroon", colorCode: "#DA6C74", backgroundImage: "admin-recognition/Maroon.png" },
        { name: "Green", colorCode: "#75B084", backgroundImage: "admin-recognition/Green.png" },
        { name: "Orange", colorCode: "#DA9B6C", backgroundImage: "admin-recognition/Orange.png" },
        { name: "Purple", colorCode: "#BE7D9C", backgroundImage: "admin-recognition/Purple.png" },
        { name: "Yellow", colorCode: "#B1AA56", backgroundImage: "admin-recognition/Yellow.png" },
        { name: "Teal", colorCode: "#DA92C8", backgroundImage: "admin-recognition/Teal.png" },
      ],
      iconData: Array(50).fill({ icon: "AdminCloseIcon" })
    };
  }

  togglePopup = () => {
    this.setState((prevState) => ({ isModalOpen: !prevState.isModalOpen }));
  };


  toggleIconPopup = () => {
    this.setState((prevState) => ({ showModal: !prevState.showModal }));
  };

  handleModal = () => {
    this.setState({ isModalOpen: true })
  }

  handleCloseColorModal = () => {
    this.setState({ isModalOpen: false, confirmColorV1:this.state.themeColor })
  }

  onSelectColor = (color) => {
    this.setState({ confirmColorV1: color.colorCode,selectedColorV1:color});
  };


  handleSelectedColor = () => {
    this.setState({ isModalOpen: false, themeColor:this.state.confirmColorV1  })
    // this.setState({ selectedColorV1:this.state.confirmColorV1 });
  }

  onChangeColor = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  handleCloseModal = () => {
    this.setState({ showModal: false, selectedIcon: this.state.selectedIconV1, selectedValueIcon: this.state.selectedValueIconV1  });
  }

  handleSaveData = () => {
    this.setState({ showModal: false,selectedIconV1: this.state.selectedIcon, selectedValueIconV1: this.state.selectedValueIcon });
  }

  handleIconClick = (index, icon) => {
    this.setState({ selectedIcon: index, selectedValueIcon: icon });

  };

  componentDidMount() {
    this.getCoreValueIcons();
  }

  onChange = (e) => {
    let file = e.target.files[0];
    let fileArr = e.target.files;
    if (e.target.files[0]) {
      if (checkImage(fileArr)) {
        if (file?.size / 1000000 <= 20) {
          let reader = new FileReader();
          reader.readAsDataURL(file);
          const array = document
            .getElementById("event-upload-file")
            .value.split("\\");
          reader.onloadend = () => {
            this.setState({
              imgSrc: reader.result,
              imageName: array[array.length - 1],
            });
            getOrientation(file, (or) => {
              resetOrientation([reader.result], or, (baseImage) => {
                this.setState({
                  imgSrc: baseImage,
                });
              });
            });
          };
        } else {
          toast.error("Please select image file less than 20MB");
          document.getElementById("event-upload-file").value = "";
        }
      } else {
        toast.error(imageErrorMessage);
        document.getElementById("event-upload-file").value = "";
      }
    }
  };


  backgroundColorName = [
    {
      id: 1,
      name: 'Light Pink',
      colorCode: "#F4AAA9"

    },
    {
      id: 2,
      name: 'Pink',
      colorCode: "#DC94B5"
    },
    {
      id: 3,
      name: 'Purple',
      colorCode: "#AF87C1"
    },
    {
      id: 4,
      name: 'Blue',
      colorCode: "#6781C3"
    },
    {
      id: 5,
      name: 'Sky Blue',
      colorCode: "#85C0EA"
    },
    {
      id: 6,
      name: 'Peacock Blue',
      colorCode: "#007AB1"
    },
    {
      id: 7,
      name: 'Dark Green',
      colorCode: "#006F88"
    },
    {
      id: 8,
      name: 'Green',
      colorCode: "#76AB78"
    },
    {
      id: 9,
      name: 'Yellow',
      colorCode: "#F1C977"
    },
    {
      id: 10,
      name: 'Orange',
      colorCode: "#FFBF73"
    },
  ];

  removePhoto = () => {
    this.setState({
      imgSrc: "",
      imageName: "",
    });
  };

  onSelectPoints = (name) => {
    this.setState({
      [name]: name.value,
      eventPointKey: name.key,
      eventPointValue: name.value,
    });
  };


  onSelectColors = (name) => {
    this.setState({
      selectedColor: name
    });
  };

  submitCoreValues = async () => {
    const { title, eventPointValue, description, selectedValueIconV1, selectedColorV1,themeColor } = this.state
    const companyId = this.props.companyInfo?.id;
    const payload = {
      title: title,
      description: description,
      icon: selectedValueIconV1?.blue_icon,
      bg_color: themeColor,
      points: eventPointValue,
      post_bg_image: selectedColorV1?.backgroundImage ,
      white_icon: selectedValueIconV1?.white_icon,
    }

    try {
      const response = await fetchApi(CreateCustomCoreValue + "/" + companyId, 'POST', payload);
      if (response.status === 'success') {
        toast.success(response.data[0]);
        this.props.history.push({ pathname: `/company/recognition`, state: { activeTab: 6, activeTabV: "Active" } });

      } else {
        toast.error(response.error);
      }
    } catch (error) {
      window.console.error(error);
    }
  };


  

  saveData = () => {
    const {
      title,
      description,
      eventPointValue,
      recognitionId,
      //   status
    } = this.state;
    const { companyInfo } = this.props;
    const RecognitionDetails = {
      company_id: companyInfo?.id,
      is_deleted: [],
      recognitions: [
        {
          core_value: title,
          description: description,
          id: recognitionId,
          point: eventPointValue,
          //   status: status
        }
      ]
    };

    this.PostRecognition(RecognitionDetails);
  };

  PostRecognition = async (payload) => {
    try {
      const res = await fetchApi(AddCompanyExemplifiesValues, "POST", payload);
      if (res?.data?.message) {
        toast.error(res.data.message);
        this.setState({
          buttonStatus: false,
        });
      } else {
        toast.success(res.data[0]);
        this.props.history.push(`/company/recognition/addcorevalues`);
      }
    } catch (error) {
      toast.error(error)
    }
  }



  getCoreValueIcons = async () => {
    let apiUrl = GetCoreValueIcons;
    try {
      const res = await fetchApi(apiUrl, "GET");
      if (res.status === "success") {
        this.setState({ coreValueLibraryIcons: res.data })
      } else {
        toast.error(res.error);
      }
    } catch (error) {
      window.console.error(error);
    }
  }

  onChangeDescription = (evt) => {
    const newContent = evt.getData();
    const trimmedString = newContent.replace(/\s|&nbsp;/g, "");
    trimmedString.length === 0 ||
      trimmedString.length === 7 ||
      trimmedString == "<p></p><p></p>"
      ? this.setState({ description: "" })
      : this.setState({ description: newContent }, () => {
        try {
          const parsedContent = parse(this.state.description);
          const textLength = parsedContent?.[0]?.props?.children?.[0]?.length || 0;

          if (textLength > 300) {
            this.setState({ disableButton: true });
          } else {
            this.setState({ disableButton: false });
          }

        } catch (error) {
          console.error("Parsing error:", error);
        }
      });


  };

  updateStep = (value) => {
    this.setState({ step: value, buttonClickScrollTop: true });
  };

  nextStep = (value) => {
    this.setState({
      step: value,
      buttonClickScrollTop: true,
      buttonStatus: false,
    });
  };

  redirect = () => {
    this.props.history.goBack();
  };

  renderHeading = () => (
    <Heading color={"#184A61"}>
      <div className="close-icon" onClick={this.redirect}>
        <ManagerIconContainer isWidth={"34px"}>{RecognitionCloseIcon('#F37A65')}</ManagerIconContainer>
      </div>
      {this.props.t("Create Core Value ")}
    </Heading>
  );

  onChangeInput = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  getTextLength = (htmlString) => {
    if (!htmlString) return 0;
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = htmlString;
    return tempDiv.textContent.length;
  };
 
  toggleModal = () => {
    this.setState((prevState) => ({ showModal: !prevState.showModal }));
  };

  stepOneForm = () => {
    
    const {
      title,
      description,
      step,
      //   iconColor,
      showModal,
      // iconData,
      //   icon,
      // selectedIcon,
      // selectedColor,
      
      confirmColorV1,
      coreValueLibraryIcons,
      selectedValueIconV1,
      themeColor,
      selectedValueIcon
    } = this.state;

   
    const { t } = this.props;
    return (
      <Layout>
        <div className="main" >
          {this.renderHeading()}
          <Container color="#005C87">
            <div className="stepsNameHighlight">
              <StepsHeading stepCount={step} type="create-core-value" padding="20px 20px 265px 20px" />
            </div>
            <div className="form">
             
              <div className="formBody">
                <InputContainer>
                  <StyledLabel isFont={"14px"} color={"#184A61"} margin="0px">{this.props.t("Title of the core value")}</StyledLabel>
                  <StyledInputV2
                    placeholder={t("Enter text")}
                    name="title"
                    value={title}
                    maxLength="25"
                    style={{ background: "white" }}
                    pColor={"#BDBDBD"}
                    color="#184A61"
                    onChange={this.onChangeInput}
                    isBorderColor={"1px solid #BDBDBD"}
                  />
                  <div className="count">{title?.length}/25 | C</div>
                </InputContainer>
                {/* <Border style={{background:'rgba(0, 92, 135, 0.10)',margin:'20px 0px 0px 0px'}}/> */}
                {/* <InputContainer>
                  <StyledLabel color={"#005c87"}>{this.props.t("Core Value icon")}{<span>*</span>}</StyledLabel>
                  <div style={{ display: 'flex', alignItems: 'center', marginBottom: '5px' }}>
                    {selectedIcon && (
                      <img
                        src={`${ImageUrl}/${selectedIcon.blue_icon}`} 
                        alt="Icon"
                        style={{ width: '24px', height: '24px', marginRight: '8px' }} 
                      />
                    )}


                    <StyledInputV2
                      placeholder={t("Select icon")}
                      name="icon"
                      // value={icon}
                      maxLength="100"
                      //   value={selectedIcon ? selectedIcon.blue_icon : ""} 
                      style={{background:"white"}}
                      pColor={"#649bb3"}
                      color="#005c87"
                      onClick={this.toggleModal} 
                      readOnly 
                      // onChange= { this.onChangeInput}
                      border={"1px solid rgba(0, 122, 177, 0.30)"}
                    />

                  </div>
                </InputContainer> */}
                {/* <InputContainer>
                  <StyledLabel color={"#184A61"}>
                    {this.props.t("Core value icon")}
                   
                  </StyledLabel>
                  <div style={{ position: 'relative', display: 'flex', width:"100%" }}>
                    {selectedIcon ? (
                      <div
                        style={{
                          position: 'absolute',
                          left: '20px', 
                          top: '60%',
                          transform: 'translateY(-50%)', 
                          width: '36px', 
                          height: '36px', 
                          pointerEvents: 'none', 
                        }}><img src={ImageUrl+"/"+selectedValueIcon?.blue_icon} width={"24px"} height={"auto"}/></div>
                    ) : null}
                
                    <StyledInputV2
                      placeholder={selectedIcon ?  "" : this.props.t("Select icon")}
                      name="icon"
                      maxLength="100"
                      value={""}
                      style={{
                        background: "white",
                        // paddingLeft: selectedIcon ? '12px' :'35px', 
                        width:"100%"
                      }}
                      pColor={"#BDBDBD"}
                      color="#184A61"
                      onClick={this.toggleModal}
                      readOnly
                      isBorderColor={"1px solid #BDBDBD"}
                    />
                  </div>
                </InputContainer> */}



              
                <Border style={{ background: 'rgba(0, 92, 135, 0.10)', margin: '20px 0px' }} />
                <div style={{ display: "flex", width: "50%" }}>
                  <InputContainer width="auto" style={{ minWidth: "110px" }}>
                    <StyledLabel isFont={"14px"} color={"#184A61"} margin={"0px"}>{this.props.t("Background color")}</StyledLabel>
                    <ButtonWrapper isMargin={"14.5px"}>
                      <CircleButton color={themeColor} onClick={this.togglePopup}>
                        <div>{themeColor ? null :  AddIconRecognition()}</div>
                      </CircleButton>
                      {themeColor && (
                        <EditButton onClick={this.togglePopup}>
                          <div className="editIcon">{RecognitionBoldPencilIcon()}</div>
                        </EditButton>
                      )}
                    </ButtonWrapper>
                  </InputContainer>
                  <div style={{
                    display: "flex",
                    alignItems: "center",
                  }}>
                    <VerticalBorder />
                  </div>
                  <InputContainer style={{ minWidth: "28%" }}>
                    <StyledLabel isFont={"14px"} color={"#184A61"} margin={"0px"}>{this.props.t("Core value icon")}</StyledLabel>
                    <ButtonWrapper isMargin={"7.5px"}>
                      <CircleButton /*color={this.state.selectedColorV1?.colorCode}*/ color={selectedValueIconV1? themeColor: null} onClick={this.toggleIconPopup}>
                        {selectedValueIconV1 ? (
                          <div
                            style={{
                              position: 'absolute',
                              left: '28px',
                              top: '55%',
                              transform: 'translateY(-50%)',
                              width: '36px',
                              height: '36px',
                              pointerEvents: 'none',
                            }}>{themeColor ? <img src={ImageUrl + "/" + selectedValueIconV1?.white_icon} width={"24px"} height={"auto"} />: <img src={ImageUrl + "/" + selectedValueIconV1?.blue_icon} width={"24px"} height={"auto"} />}</div>
                        ) : AddIconRecognition()}
                      </CircleButton>
                      {this.state.selectedValueIconV1 && (
                        <EditButton onClick={this.toggleIconPopup}>
                          <div className="editIcon">{RecognitionBoldPencilIcon()}</div>
                        </EditButton>
                      )}
                    </ButtonWrapper>
                  </InputContainer>
                </div>
                <Border style={{ background: 'rgba(0, 92, 135, 0.10)', margin: '20px 0px' }} />

                <StyledModalV1 show={this.state.isModalOpen} onHide={this.handleCloseColorModal} width="800px" height="240px">
                  <div className="modal-content-padding">
                    <div className="header-wrapper">
                      <div className="heading">{t("Choose Background Color For Icon")}</div>
                      <div className="close-icon" onClick={this.handleCloseColorModal}>
                        {AdminCloseIcon()}
                      </div>
                    </div>
                    <Border style={{ background: '#EFEFEF', margin: '16px 0px' }} />
                    <ColorGrid>
                      {this.state.colors.map((color) => (
                        <ColorBox
                          key={color.colorCode}
                          style={{ background: color.colorCode }}
                          onClick={() => this.onSelectColor(color)}
                        >{confirmColorV1 === color.colorCode ? <div className="tickIcon">{RecognitionTickIcon("white",15,10)}</div> : null}
                        </ColorBox>
                      ))}
                    </ColorGrid>
                    <Border style={{ background: '#EFEFEF', margin: '16px 0px' }} />
                    <ModalFooter>
                      {/* <button className="confirm-btn" onClick={this.handleSelectedColor}>
                        <div> {("Select Color")}</div>
                        <div className="icon"> {RecognitionTickIcon("white",16,10)}</div>
                      </button> */}
                      {/* <ButtonCustom
                        isButtoHeight=""
                        isBg={true}
                        color="red"
                        hoverColor="#5a6268"
                        padding="12px"
                      >
                        <div style={{ position: 'absolute', width: '200px', height: '40px' }}>
                          <input
                            type="color"
                            name="themeColor"
                            onChange={this.onChangeColor}
                            style={{
                              position: 'absolute',
                              top: 0,
                              left: 0,
                              width: '100%',
                              height: '100%',
                              opacity: 0,
                              zIndex: 1,
                              cursor: 'pointer',
                            }}
                          />  </div>
                        <AdminIconContainer isWidth={"16px"} isHeight={"16px"}>
                          {UploadHDMIcon()}
                        </AdminIconContainer>{" "}
                        Choose custom color
                      </ButtonCustom> */}
                      <CommonButtonPopup background={confirmColorV1?"#F37A65":"#EFEFEF"} color={confirmColorV1?"#FEFEFE":"#989898"} onClick={confirmColorV1? this.handleSelectedColor :null}>
                        {("Select Color")}{RecognitionTickIcon(confirmColorV1?'white':"#989898")}
                      </CommonButtonPopup>
                    </ModalFooter>
                  </div>
                </StyledModalV1>


                {showModal && (

                  <StyledModalV1 isPadding={"0px 16px"} show={showModal} onHide={this.handleCloseModal} width="600px" height="424px">
                    <div className="modal-content-padding">
                      <div className="header-wrapper">
                        <div className="heading">{t("Choose Core Value Icon")}</div>
                        <div className="close-icon" onClick={this.handleCloseModal}>
                          {AdminCloseIcon()}
                        </div>
                      </div>
                      <Border style={{ background: '#EFEFEF', margin: '16px 0px' }} />
                      <IconGrid>
                        {coreValueLibraryIcons?.length > 0 ? (
                          this.state.coreValueLibraryIcons?.map((icon, index) => (
                            <IconWrapper
                              key={index}
                              isSelected={this.state.selectedIcon === index}
                              onClick={() => this.handleIconClick(index, icon)}>
                              <img src={this.state.selectedIcon === index ? ImageUrl + "/" + icon?.white_icon : ImageUrl + "/" + icon?.blue_icon} />
                            </IconWrapper>
                          ))
                        ) : (
                          <p>No icons available</p>
                        )}
                      </IconGrid>
                      <Border style={{ background: '#EFEFEF', margin: '16px 0px' }} />
                      <ModalFooter>
                        <CommonButtonPopup background={selectedValueIcon?"#F37A65":"#EFEFEF"} color={selectedValueIcon?"#FEFEFE":"#989898"} onClick={selectedValueIcon? this.handleSaveData:null}>
                          {("Select Icon")}{RecognitionTickIcon(selectedValueIcon?'white':"#989898")}
                        </CommonButtonPopup>
                      
                      </ModalFooter>
                    </div>
                  </StyledModalV1>
                )}

                <InputContainer isColorError={parse(description)?.[0]?.props?.children?.[0]?.length > 300}>
                  <StyledLabel isFont={"14px"} style={{ marginTop: "0px" }} color={"#184A61"}>{this.props.t("About the core value")}</StyledLabel>
                  <EditorContainer>
                    <Editor
                      content={description}
                      onChange={this.onChangeDescription}
                    />
                  </EditorContainer>
                  <div className="char-count">
                    {this.getTextLength(description)}/300 | C
                  </div>
                  {/* <div className="char-count">{parse(description)?.[0]?.props?.children?.[0]?.length || 0}/300 | C</div> */}
                </InputContainer>
              </div>
            </div>
          </Container>
        </div>
      </Layout>
    );
  };

  stepTwoForm = () => {
    const {
      step,
      eventPointValue,
      pointsArray
    } = this.state;
    return (
      <Layout>
        <div className="main">
          {this.renderHeading()}
          <Container isHeight="104px" color={"#005c87"}>
            <div className="stepsNameHighlight">
              <StepsHeading stepCount={step} type="create-core-value" padding="20px 20px 265px 20px" />
            </div>
            <div className="form">
              <div className="formBody">
                <CommonDropdown
                  tileContainerStyle={{ width: "100%", padding: "20px 0px 20px 0px" }}
                  dropdownStyle={{ top: "90px" }}
                  labelText={this.props.t("Core value point")}
                  // isRequired={true}
                  dropdownOpen={this.state.so}
                  placeholder={this.props.t("Select Point Value")}
                  title={
                    eventPointValue || eventPointValue === 0 ? eventPointValue + " Points" : +"No Points"
                  }
                  id="dropdown-recurring"
                  onClick={() => this.setState({ so: !this.state.so })}
                  data={pointsArray}
                  onSelect={this.onSelectPoints}
                  active={eventPointValue}
                  onSelectParameter={["eventPointValue", "value", "key"]}
                  valueString={"Points"}
                  itemValue={true}
                  valueIndex={1}
                  labelMargin={"0px"}
                  fontSize={"14px"}
                  dropIcon={true}
                />
              </div>
            </div>
          </Container>
        </div>
      </Layout>
    );
  };

  render() {
    const {
      step,
      buttonStatus,
      disableButton,
      title,
      description,
      selectedValueIconV1,
      eventPointValue,
      themeColor
    } = this.state;

    return (
      <React.Fragment>
        {step === 1
          ? this.stepOneForm()
          : step === 2
            ? this.stepTwoForm()
            : null}
        {step === 1 ? (
          <ButtonContainer>
            <Main>
              {/* <CommonButton
                btnType={"squareIcon"}
                onClick={() => this.updateStep(2)}
                disabled={!title || !description || !selectedValueIcon || !themeColor}
                // disabled={disableButton}
                title={this.props.t("Next")}
                styles={{ color: "#F37A65", height: "48px", border: "#F37A65", padding: "16px 20px", width: "90px", background: "#F37A65", fontFamily: "Lato", fontSize: "16px" }}
                nextIcon={disableButton ? AdminRightArrowIcon("#989898") : AdminRightArrowIcon()}
              /> */}

              <CommonButtonPopup height="48px" width="90px" margin="auto 0 auto auto" disabled={!title || !description || !selectedValueIconV1 || !themeColor || disableButton} onClick={!title || !description || !selectedValueIconV1 || !themeColor || disableButton?null: () => this.updateStep(2)}>
                   Next
                {!title || !description || !selectedValueIconV1 || !themeColor || disableButton ? AdminRightArrowIcon("#989898") : AdminRightArrowIcon()}
              </CommonButtonPopup>
            </Main>
          </ButtonContainer>
        ) :
          step === 2 && (
            <ButtonContainer>
              {/* <div className="wrapper">
                <CommonButton
                  btnType={"squareIcon"}
                  styles={{ color: "white", marginRight:"8px", textColor: "#184A61", padding: "16px 20px", height: "52px", border: "#F37A65", width: "90px", marginLeft: "0px", display: "flex", justifyContent: "center", alignItems: "center" }}
                  onClick={() => this.nextStep(1)}
                  title={this.props.t("Back")}
                  icon={AdminLeftArrowIcon()}
                />
                <CommonButton
                  btnType={"squareIcon"}
                  disabled={!eventPointValue}
                  styles={{ color: "#F37A65", marginAuto: 'auto', display: "flex", border: "#F37A65", width: "202px" }}
                  onClick={!buttonStatus ? () => this.submitCoreValues() : null}
                  title={this.props.t("Create Core Value")}
                  nextIcon={LaunchIcon()}
                  style={{ display: "flex" }}
                />
                
              </div> */}

              <div className="wrapper">
                <CommonButtonBorder width="90px" height="48px" onClick={() => this.nextStep(1)} margin="auto auto auto 0px">
                  {AdminLeftArrowIcon("#F37A65")}
                  Back
                </CommonButtonBorder>
                <CommonButtonPopup margin="auto 0 auto auto" width="194px" height="48px" disabled={eventPointValue === null || eventPointValue === undefined} onClick={eventPointValue === null || buttonStatus || eventPointValue === undefined ? null: () => this.submitCoreValues()}>
                Create Core Value{eventPointValue === null  || eventPointValue === undefined ? LaunchIcon("#989898"):LaunchIcon()}
                </CommonButtonPopup>
              </div>
            </ButtonContainer>
          )}
      </React.Fragment>
    );
  }
}

CreateCoreValue.propTypes = {
  history: PropTypes.object.isRequired,
  role: PropTypes.string.isRequired,
  t: PropTypes.func,
  companyInfo: PropTypes.object
};

export default (withRouter(withTranslation()(CreateCoreValue)));
